import React from "react";
import { Link } from "react-router-dom";
import "./partners.css";

import image1 from "../../assets/icons/service_1.png";
import image2 from "../../assets/icons/service_2.png";
import image3 from "../../assets/icons/service_3.png";
import image4 from "../../assets/icons/service_4.png";

const SERVICES = [
  {
    id: "asic",
    title: "ASIC / FPGA Services",
    desc:
      "High-performance ASIC & FPGA design, verification, and semiconductor engineering expertise.",
    icon: image1,
    link:'staffing-service'
  },
  {
    id: "it",
    title: "IT Services",
    desc:
      "End-to-end IT solutions including development, cloud modernization, and automation.",
    icon: image2,
    link:'software-service'
  },
  {
    id: "consulting",
    title: "Consulting & Recruitment",
    desc:
      "Expert consulting and recruitment solutions to help organizations scale globally.",
    icon: image3,
    link:'consulting-service'
  },
   {
    id: "Project outsourcing",
    title: "Project Outsourcing",
    desc:
      "Comprehensive project outsourcing services for efficient delivery and management.",
    icon: image4,
    link:'project-service'
  },
];

const Partners: React.FC = () => {
  return (
    <section className="services-showcase">
      <div className="services-showcase__left">
        <span className="services-chip">SERVICES</span>

        <h2 className="services-title">
          Your Partner in <span>Digital</span> Success
        </h2>

        <p className="services-sub">
          We design, build, and scale technology solutions across semiconductor
          and enterprise IT.
        </p>
      </div>

      <div className="services-showcase__cards">
        {SERVICES.map((s) => (
          <article key={s.id} className="service-card">
            <img src={s.icon} alt="" className="service-icon" />

            <h3>{s.title}</h3>
            <p>{s.desc}</p>

            <Link to={`/services/${s.link}`} className="service-link">
              Learn More →
            </Link>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Partners;
